<div class="req-container container">
<!--    <div class="req-data-header"></div>-->
    <div class="req-data-content">
<!--        <ng-container *ngIf="onPersonalRequiredScreen">-->
<!--            <app-personal-data-request-screen-->
<!--                (userContinue)="userCanContinue()">-->
<!--            </app-personal-data-request-screen>-->
<!--        </ng-container>-->
        <ng-container *ngIf="onPersonalDataScreen">
            <app-profile-personal
                [externalInstance]="false"
                [hideLastName2]="true"
                [hideRfc]="true"
                [hideCurp]="true"
                (confirmChanges)="confirmChanges($event)">
            </app-profile-personal>
        </ng-container>
    </div>
    <div class="req-data-bottom"></div>
</div>


